import { useTranslation } from "react-i18next";
import RegistrationHeader from "@/components/auth/registration/Header.tsx";
import { cn } from "@edusogno/lib/utils";
import RegistrationContent from "@/components/auth/registration/Content.tsx";
import OutlinedSelect from "@edusogno/inputs/outlined-select";
import RegistrationContainer from "@/components/auth/registration/Container.tsx";
import LoadingButton from "@edusogno/primitives/loading-button";
import AuthPageFooter from "@edusogno/layouts/auth-page-footer.js";
import useFormStep from "@/utils/hooks/useFormStep.ts";
import { useEffect, useState } from "react";

interface ChannelProps {
  className?: string;
  onNext: () => void;
}

const RegistrationChannel = ({ className, onNext }: ChannelProps) => {
  const { invalid, defaultValue, handleChange, error } = useFormStep("referer");
  const { t } = useTranslation();
  const [title, setTitle] = useState(t("auth.registration.channel_title"));
  const [subtitle, setSubtitle] = useState(t("auth.registration.channel_subtitle"));

  useEffect(() => {
    const language = localStorage.getItem("i18nextLng");
    if (language === "it") {
      setTitle("Come conosci Edusogno?"); // Update the title for Italian users
      setSubtitle("Facci sapere come hai scoperto Edusogno"); // Update the subtitle for Italian users
    }
  }, []);

  const options = [
    { label: "Instagram", value: "instagram" },
    { label: "Facebook", value: "facebook" },
    { label: "Youtube", value: "youtube" },
    { label: "Tik Tok", value: "tiktok" },
    { label: "Google", value: "google" },
    { label: "Linkedin", value: "linkedin" },
    { label: "Newspaper/Radio", value: "newspaper/radio" },
    { label: "A Friend", value: "a-friend" },
  ];

  return (
    <>
      <RegistrationContainer className={cn("h-full", className)}>
        <RegistrationHeader
          title={title} // Use the dynamically updated title
          subtitle={subtitle} // Use the dynamically updated subtitle
          logo={"channel"}
        />
        <RegistrationContent>
          <OutlinedSelect
            className={"w-full"}
            label={t("auth.labels.channel")}
            placeholder={t("auth.registration.select_channel")}
            color={"grey"}
            defaultValue={defaultValue}
            onValueChange={handleChange}
            options={options}
          />
          {error?.message && (
            <p className="mt-2 text-sm text-red-600">{error.message}</p>
          )}
        </RegistrationContent>
      </RegistrationContainer>
      <AuthPageFooter>
        <LoadingButton
          size={"lg"}
          type="button"
          className="hidden w-full text-lg tracking-wide md:block"
          disabled={invalid}
          onClick={() => onNext()}
        >
          {t("btns.next")}
        </LoadingButton>
        <LoadingButton
          size={"md"}
          type="button"
          className="block w-full text-lg tracking-wide md:hidden"
          disabled={invalid}
          onClick={() => onNext()}
        >
          {t("btns.next")}
        </LoadingButton>
      </AuthPageFooter>
    </>
  );
};

export default RegistrationChannel;